/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";

export const ReactTableCell = ({ header, value, synonymList }: any) => {
  switch (header) {
    case "status": {
      return (
        <Badge variant={value ? "default" : "destructive"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      );
    }
    case "synonym_mapping": {
      const currentData = synonymList.find(
        (item: any) => item.domain_id === value
      );
      return <span className="uppercase">{currentData?.name || value}</span>;
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
